import { render, staticRenderFns } from "./ResultContent.vue?vue&type=template&id=f8723bc2&scoped=true&"
import script from "./ResultContent.vue?vue&type=script&lang=js&"
export * from "./ResultContent.vue?vue&type=script&lang=js&"
import style0 from "./ResultContent.vue?vue&type=style&index=0&id=f8723bc2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8723bc2",
  null
  
)

export default component.exports